















import { Component, Vue } from 'vue-property-decorator';
import {
  Button, Table, TableColumn, Scrollbar, Loading, Message, DatePicker, Progress,
} from 'element-ui';
import Read from '@/servers/modules/read/read'; // server
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class';

    @Component({
      components: {
        Table,
        TableColumn,
        Progress,
        Button,
      },
    })
export default class extends Vue {
  private tableData:any = [];

  private tableHeaderClassName() {
    return 'table-header';
  }

  private tableRowClassName() {
    return 'table-row';
  }

  private created() {
    this.init();
  }

  private async init() {
    const res = await Read.queryReadingGuideList({ courseId: window.LS.get('basicData').courseId }).catch((e:any) => {
      console.log(e);
    });
    if (!res.data.code) {
      this.tableData = res.data.data;
    }
  }

  // 查看阅读指导内容
  private showDetail(docId:any) {
    this.$router.push(`/read/guide?docId=${docId}`);
  }
}
